<template>

  <svg viewBox="0 0 24 24" role="presentation" focusable="false" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 12v7c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2H5v-1c0-3.87 3.13-7 7-7s7 3.13 7 7v1h-2c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2v-7a9 9 0 00-18 0z" fill="#E65997"/><path d="M3 12v1h2v-1c0-3.87 3.13-7 7-7s7 3.13 7 7v1h2v-1a9 9 0 00-18 0z" fill="#F2ACCB"/></svg>

</template>


<script>

  export default {"name":"icon-82837e3e621bce816b679bbf3c42bff4"}

</script>